var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("header", { staticClass: "header" }, [
      _c(
        "div",
        {
          staticClass: "back",
          on: {
            click: function ($event) {
              return _vm.$router.back()
            },
          },
        },
        [
          _c("img", {
            attrs: { src: require("images/back.png"), width: "10" },
          }),
          _c("span", [_vm._v("返回")]),
        ]
      ),
    ]),
    !_vm.ifUpdate
      ? _c(
          "div",
          { staticClass: "top" },
          [
            _c("gao-kao-step", {
              attrs: {
                active: 2,
                newFlag: _vm.newFlag,
                examType: _vm.examType,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _c("div", { staticClass: "content" }, [
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "space-between",
            "align-items": "center",
          },
        },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "130px" },
              attrs: { disabled: "", value: _vm.examLevelType },
            },
            _vm._l(_vm.typeList, function (t, i) {
              return _c("el-option", {
                key: i,
                attrs: { label: t.name, value: t.id },
              })
            }),
            1
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.generateList },
            },
            [_vm._v("重置")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "card-container" },
        [
          _vm._m(0),
          _vm._l(_vm.levelList, function (l, i) {
            return _c("div", { key: i, staticClass: "card" }, [
              i == _vm.levelList.length - 1
                ? _c("img", {
                    staticClass: "delete",
                    staticStyle: { height: "14px", width: "14px" },
                    attrs: { src: require("images/delete_white.png"), alt: "" },
                    on: { click: _vm.deleteLevel },
                  })
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "index",
                  style: { background: _vm.colorList[i] },
                },
                [_vm._v(_vm._s(_vm.indexLabelList[i]))]
              ),
              _c(
                "div",
                { staticClass: "score-range" },
                [
                  _c("el-input", {
                    staticStyle: { width: "50px", "text-align": "center" },
                    attrs: { min: "0", type: "number", size: "mini" },
                    model: {
                      value: l.startScore,
                      callback: function ($$v) {
                        _vm.$set(l, "startScore", _vm._n($$v))
                      },
                      expression: "l.startScore",
                    },
                  }),
                  _c("span", [_vm._v("~")]),
                  _c("el-input", {
                    staticStyle: { width: "50px", "text-align": "center" },
                    attrs: { min: "0", type: "number", size: "mini" },
                    model: {
                      value: l.endScore,
                      callback: function ($$v) {
                        _vm.$set(l, "endScore", _vm._n($$v))
                      },
                      expression: "l.endScore",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "per-percent" },
                [
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "116px", "text-align": "center" },
                      attrs: { type: "number", min: "0", size: "mini" },
                      on: { change: _vm.handleRatioChange },
                      model: {
                        value: l.ratio,
                        callback: function ($$v) {
                          _vm.$set(l, "ratio", _vm._n($$v))
                        },
                        expression: "l.ratio",
                      },
                    },
                    [_c("template", { slot: "append" }, [_vm._v("%")])],
                    2
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "total-ratio" },
                [
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "116px", "text-align": "center" },
                      attrs: { disabled: "", size: "mini" },
                      model: {
                        value: l.totalRatio,
                        callback: function ($$v) {
                          _vm.$set(l, "totalRatio", $$v)
                        },
                        expression: "l.totalRatio",
                      },
                    },
                    [_c("template", { slot: "append" }, [_vm._v("%")])],
                    2
                  ),
                ],
                1
              ),
            ])
          }),
          _vm.levelList.length <= 25
            ? _c(
                "div",
                {
                  staticClass: "card add",
                  staticStyle: { width: "116px" },
                  on: { click: _vm.addLevel },
                },
                [
                  _vm._m(1),
                  _c("div", { staticClass: "text" }, [_vm._v("新增")]),
                ]
              )
            : _vm._e(),
        ],
        2
      ),
    ]),
    _c(
      "div",
      {
        staticStyle: {
          "text-align": "center",
          "margin-top": "40px",
          "padding-bottom": "40px",
        },
      },
      [
        _c(
          "el-button",
          {
            staticStyle: { "padding-left": "30px", "padding-right": "30px" },
            attrs: {
              round: "",
              type: "primary",
              size: "small",
              loading: _vm.loading,
            },
            on: { click: _vm.save },
          },
          [_vm._v("完成")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card title" }, [
      _c(
        "div",
        {
          staticStyle: {
            "line-height": "30px",
            color: "#333",
            "font-size": "14px",
          },
        },
        [_vm._v("等级")]
      ),
      _c(
        "div",
        {
          staticClass: "score-range",
          staticStyle: { "line-height": "30px", color: "#333" },
        },
        [_vm._v("赋分分值:")]
      ),
      _c(
        "div",
        {
          staticClass: "per-percent",
          staticStyle: { "line-height": "30px", color: "#333" },
        },
        [_vm._v("分段比例:")]
      ),
      _c(
        "div",
        {
          staticClass: "total-ratio",
          staticStyle: { "line-height": "30px", color: "#333" },
        },
        [_vm._v("累计比例:")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("i", { staticClass: "el-icon-circle-plus" })])
  },
]
render._withStripped = true

export { render, staticRenderFns }